module.exports = __webpack_public_path__ + "images/banners/sns_campaign/tweet_campaign202008_banner_sp_92ac54e5c0037326e8ac56e39a25f338.jpg";